import { Color } from "utils/theme";

export const StatusSection = ({ title, description = "", children }) => {
  return (
    <div className="mb-6">
      <h2 className="text-lg font-medium" style={{ color: Color.White }}>
        {title}
      </h2>
      <p className="mb-2 text-sm" style={{ color: Color.Primary[500] }}>
        {description}
      </p>
      <div className="overflow-hidden space-y-2">{children}</div>
    </div>
  );
};
